/**
 * @generated SignedSource<<3bf62fd3805136d4c91900b1394e722c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonPlayMode = "ANSWER" | "LISTEN" | "%future added value";
export type StartLessonPlayInput = {
  lessonId: string;
  localDay: any;
  mode: LessonPlayMode;
};
export type LessonPlayerStartMutation$variables = {
  input: StartLessonPlayInput;
};
export type LessonPlayerStartMutation$data = {
  readonly startLessonPlay: {
    readonly id: string;
  };
};
export type LessonPlayerStartMutation = {
  response: LessonPlayerStartMutation$data;
  variables: LessonPlayerStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonPlay",
    "kind": "LinkedField",
    "name": "startLessonPlay",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonPlayerStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonPlayerStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "2fba3159a0977d811b97d6cbbbe382e4",
    "id": null,
    "metadata": {},
    "name": "LessonPlayerStartMutation",
    "operationKind": "mutation",
    "text": "mutation LessonPlayerStartMutation(\n  $input: StartLessonPlayInput!\n) {\n  startLessonPlay(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2875959581fd06ea2b08d6e776ae0e13";

export default node;
